export class PreloaderHelper {
    public static togglePreloader(state): void {
        const preloader = document.getElementById('preloader');

        if (state) {
            preloader.style.display = 'flex';
        } else {
            preloader.style.display = 'none';
        }
    }
}